'use client';

import { APP_ROUTE } from '@src/constants/routes';
import { ZEME_USERS_ROLE } from '@src/constants/configs';
import { getUserType, isLoggedIn } from '@src/utils/localStorage';
import { useRouter } from 'next/navigation';
import Script from 'next/script';
import React, { useEffect } from 'react';

const Home = () => {
  const route = useRouter();

  useEffect(() => {
    if (
      isLoggedIn() &&
      (getUserType().toLowerCase() === ZEME_USERS_ROLE.AGENT.toLowerCase() ||
        getUserType().toLowerCase() === ZEME_USERS_ROLE.LANDLORD.toLowerCase())
    ) {
      route.push(APP_ROUTE.AGENT_DASHBOARD);
    } else {
      route.push(APP_ROUTE.EXPLORE);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Script src="https://www.googletagmanager.com/gtag/js?id=G-J6VRJLMG2H" />
      <Script id="google-analytics">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
 
          gtag('config', 'G-J6VRJLMG2H');
        `}
      </Script>
      {/* <LandingPage /> */}
    </>
  );
};

export default Home;
